import {XIcon} from '@primer/octicons-react'
/* eslint-disable-next-line primer-react/no-deprecated-flash -- Existing Flash usage should be migrated to Banner. */
import {Flash, IconButton} from '@primer/react'
import type {ComponentProps, PropsWithChildren, ReactNode, Ref} from 'react'

import styles from './DismissibleFlash.module.css'

interface DismissibleFlashProps {
  variant: ComponentProps<typeof Flash>['variant']
  onClose(): void
  ref?: Ref<HTMLDivElement>
}

export function DismissibleFlash({
  variant,
  onClose,
  children,
  ref,
}: PropsWithChildren<DismissibleFlashProps>): React.ReactElement | null {
  return (
    <Flash variant={variant} tabIndex={0} ref={ref} className={styles.DismissibleFlashContainer}>
      {children}
      <IconButton
        variant="invisible"
        icon={XIcon}
        aria-label="Dismiss message"
        onClick={onClose}
        size="small"
        className={styles.dismissButton}
      />
    </Flash>
  )
}

// switch to new Primer React "Banner" component when it's ready: https://github.com/github/primer/issues/2807

export type FlashAlert = {message: string; icon?: ReactNode; variant: ComponentProps<typeof Flash>['variant']}

function resetFlashAlert(setFlashAlert: (flashAlert: FlashAlert) => void) {
  setFlashAlert({message: '', variant: 'default'})
}

interface DismissibleFlashOrToastProps {
  flashAlert: FlashAlert
  setFlashAlert: (flashAlert: FlashAlert) => void
  ref?: Ref<HTMLDivElement>
}

export function DismissibleFlashOrToast({
  flashAlert,
  setFlashAlert,
  ref,
}: DismissibleFlashOrToastProps): React.ReactElement | null {
  if (flashAlert.message) {
    return (
      <DismissibleFlash variant={flashAlert.variant} onClose={() => resetFlashAlert(setFlashAlert)} ref={ref}>
        {flashAlert.message}
      </DismissibleFlash>
    )
  }
  return null
}
